// extracted by mini-css-extract-plugin
export default {"invalid":"TipoServicioEdit_invalid__zMfxt","spinnerContainer":"TipoServicioEdit_spinnerContainer__AklG+"};